var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('dispatcherNav'),_c('dispatcherInfo')],1),_c('div',{staticClass:"dispatcher-map"},[_c('mapComponent',{attrs:{"cars":_vm.activeCars,"calls":_vm.activeCalls},on:{"map-was-initialized":_vm.initialization}})],1),_c('dispatcherNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }